export default "/images/logo.png?cf267565101e1b8dc31f277fb1e5b4d6";